import axios from "axios";
import {API_JWT_INVALID_SUBSTRING, AUTH_EXPIRED_EVENT} from "../util/Constants";

const $host = axios.create({
    baseURL: process.env.REACT_APP_API_URL
})

const $authHost = axios.create({
    baseURL: process.env.REACT_APP_API_URL
})

const authInterceptor = config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.authorization = `Bearer ${token}`;
    }
    return config;
};

function shouldInvalidateSession(error) {
    const status = error.response?.status;
    if (status === 401) {
        return true;
    }
    if (status === 400) {
        const d = error.response?.data;
        const text = typeof d === 'string' ? d : (d?.message ?? '');
        return String(text).includes(API_JWT_INVALID_SUBSTRING);
    }
    return false;
}

$authHost.interceptors.request.use(authInterceptor);
$authHost.interceptors.response.use(
    (response) => response,
    (error) => {
        if (shouldInvalidateSession(error)) {
            window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
        }
        return Promise.reject(error);
    }
);

export {
    $host,
    $authHost
}